// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/assign-category/app/css/app.css
// module id = 789
// module chunks = 0